"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EpicGamesNavInner = void 0;
const display_when_1 = require("@epic-mw/display-when");
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const EGShield_1 = require("./components/logo/EGShield");
const PropertyLogo_1 = require("./components/logo/PropertyLogo");
const RightNav_1 = require("./components/rightnav/RightNav");
const RightNavMobile_1 = require("./components/rightnav/RightNavMobile");
const SiteNav_1 = require("./components/sitenav/SiteNav");
const defaultMessages_1 = require("./constants/defaultMessages");
const EpicGamesNav_styles_1 = require("./EpicGamesNav.styles");
const shared_1 = require("./shared");
const EpicGamesNavInner = ({ callToAction = {}, callToActionDropdown = {}, links = [], isLoggedIn, accountLoading, displayName, hideCallToAction, hideLocale, hideSearch, hideSignIn, accountLinks, localeOptions = [], onSearch, ctaMobilePosition, logoLink, collapseTargetMaxWidth, epicLogoConfig = {}, messages, topOffset = 0, burgerCallback, }) => {
    const locale = (0, epic_games_nav_shared_1.useLocalizationLocale)();
    const { setMessages } = (0, shared_1.useMessages)();
    const values = (0, epic_games_nav_shared_1.useBreakpointValues)();
    (0, react_1.useEffect)(() => {
        setMessages(Object.assign(Object.assign({}, defaultMessages_1.defaultMessages), messages));
    }, [defaultMessages_1.defaultMessages, setMessages, messages]);
    const rightNavProps = {
        links,
        callToAction,
        callToActionDropdown,
        isLoggedIn,
        accountLoading,
        displayName,
        hideCallToAction,
        hideLocale,
        hideSearch,
        hideSignIn,
        accountLinks,
        locale,
        localeOptions,
        onSearch,
        ctaMobilePosition,
        topOffset,
        burgerCallback,
    };
    const shieldEls = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(EGShield_1.EGShield, Object.assign({ key: "eg-shield", locale: locale }, epicLogoConfig)),
        react_1.default.createElement(PropertyLogo_1.PropertyLogo, { key: "prop-logo", logoLink: logoLink, locale: locale })));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(display_when_1.DisplayWhenLessThan, { width: values.md },
            react_1.default.createElement("div", { className: "nav-inner nav-inner-mobile" },
                shieldEls,
                react_1.default.createElement(RightNavMobile_1.RightNavMobile, Object.assign({}, rightNavProps)))),
        react_1.default.createElement(display_when_1.DisplayWhenGreaterThanEqual, { width: values.md },
            react_1.default.createElement("div", { className: "nav-inner nav-inner-full" },
                react_1.default.createElement(EpicGamesNav_styles_1.FlexgridLeft, { id: "leftNav" },
                    shieldEls,
                    react_1.default.createElement(SiteNav_1.SiteNav, { locale: locale, links: links, collapseTargetMaxWidth: collapseTargetMaxWidth, topOffset: topOffset, burgerCallback: burgerCallback })),
                react_1.default.createElement(RightNav_1.RightNav, Object.assign({}, rightNavProps))))));
};
exports.EpicGamesNavInner = EpicGamesNavInner;
//# sourceMappingURL=EpicGamesNavInner.js.map